export default __webpack_public_path__ + "static/media/DroppointClickingDiagram.a86155c2.png";